import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Box,
  Chip,
  Menu,
  MenuItem,
  Checkbox,
  Divider,
  Tooltip
} from "@mui/material";
import "../../analytics/process/process.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import { useState, useMemo, useCallback, useEffect } from "react";
import "./review.scss";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
  selectedCheck,
  handleCheckBox,
  is_multi_approve,
  sortConfig,
  handleSort
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowData, setRowData] = useState(null);
  const open = Boolean(anchorEl);


  // ✅ HANDLE SORT
 

  // ✅ SORT ICON
  const renderSortIcon = (column) => {
    const isActive = sortConfig.sort_by === column;

    // 👇 common style
    const baseStyle = {
      fontSize: 18,        // ⬆ bigger height
      ml: 0.5,
      color: "#154D8F",    // 🔵 your theme blue
    };

    if (!isActive) {
      return (
        <ArrowUpwardIcon
          sx={{
            ...baseStyle,
            opacity: 0.3,  // faint for inactive
          }}
        />
      );
    }

    return sortConfig.sort_order === "asc" ? (
      <ArrowUpwardIcon sx={baseStyle} />
    ) : (
      <ArrowDownwardIcon sx={baseStyle} />
    );
  };

  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setRowData(data);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const allIds = useMemo(
    () =>
      data?.data?.records
        ?.filter((r) => r?.status !== "Approved")
        .map((r) => r?.batch_id)
        .filter(Boolean),
    [data?.data?.records]
  );

  const allSelected =
    allIds?.length > 0 && selectedCheck?.length === allIds?.length;

  const isIndeterminate =
    selectedCheck?.length > 0 && selectedCheck?.length < allIds?.length;

  const selectAll = useCallback(
    (checked) => {
      if (checked) {
        handleCheckBox(allIds);
      } else {
        handleCheckBox([]);
      }
    },
    [handleCheckBox, allIds]
  );

  const toggleSelect = useCallback(
    (batchId) => {
      if (!batchId) return;
      if (selectedCheck.includes(batchId)) {
        handleCheckBox(selectedCheck.filter((id) => id !== batchId));
      } else {
        handleCheckBox([...selectedCheck, batchId]);
      }
    },
    [handleCheckBox, selectedCheck]
  );

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "calc(100vh - 210px)",
          boxShadow: "none",
        }}
      >
        <Table stickyHeader>
          <TableHead className="table-header">
            <TableRow>
              <TableCell className="table-header-cell">
                <Checkbox
                  checked={allSelected}
                  indeterminate={isIndeterminate}
                  onChange={(e) => selectAll(e.target.checked)}
                />
                {selectedCheck.length > 0 ? ` ${selectedCheck.length}` : ""}
              </TableCell>

              <TableCell className="table-header-cell">
                Batch ID
              </TableCell>

              {/* ✅ SORTABLE HEADERS */}

              <TableCell
                className="table-header-cell"
                onClick={() => handleSort("batch_date")}
                sx={{ cursor: "pointer" }}
              >
                <Box display="flex" alignItems="center">
                  Date of Manufacture
                  {/* {renderSortIcon("batch_date")} */}
                </Box>
              </TableCell>

              <TableCell
                className="table-header-cell"
                onClick={() => handleSort("approved_at")}
                sx={{ cursor: "pointer" }}
              >
                <Box display="flex" alignItems="center">
                  Approved On
                  {/* {renderSortIcon("approved_at")} */}
                </Box>
              </TableCell>

              <TableCell className="table-header-cell">
                Status
              </TableCell>

              <TableCell className="table-header-cell">
                Uploaded By
              </TableCell>

              <TableCell
                className="table-header-cell"
                onClick={() => handleSort("created_at")}
                sx={{ cursor: "pointer" }}
              >
                <Box display="flex" alignItems="center">
                  Uploaded On
                  {/* {renderSortIcon("created_at")} */}
                </Box>
              </TableCell>

              <TableCell className="table-header-cell">
                Approved By
              </TableCell>

              <TableCell className="table-header-cell">
                Source
              </TableCell>

              <TableCell className="table-header-cell">
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <Divider sx={{ border: "none", height: "2px" }} />

          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {data?.data?.records?.map((row) => (
              <TableRow
                key={row.batch_id}
                sx={{
                  backgroundColor: row.is_updated ? "#EEEEEE" : "",
                }}
              >
                {is_multi_approve ? (
                  <TableCell>
                    <Checkbox
                      checked={
                        row.status === "Approved" ||
                          row.status === "Pending"
                          ? true
                          : selectedCheck.includes(row.batch_id)
                      }
                      disabled={
                        row.status === "Approved" ||
                        row.status === "Pending"
                      }
                      onChange={() => toggleSelect(row?.batch_id)}
                      size="small"
                      sx={{ p: 0, pl: 0.5 }}
                    />
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )}

                <TableCell>
                  <Typography
                    color="primary"
                    sx={{
                      cursor: "pointer",
                      "&:hover": { textDecoration: "underline" },
                    }}
                    onClick={() => onView(row)}
                  >
                    {row.batch_id}
                  </Typography>
                </TableCell>

                <TableCell sx={{ fontSize: 14 }}>
                  {row.batch_date}
                </TableCell>

                <TableCell sx={{ fontSize: 14 }}>
                  {row.approved_at}
                </TableCell>

                <TableCell sx={{ fontSize: 14 }}>
                  <Chip
                    label={row.status}
                    className={`review-status-chip status-chip ${row.status === "Approved"
                      ? "status-chip-color-green"
                      : "status-chip-color-gray"
                      }`}
                  />
                </TableCell>

                <TableCell sx={{ fontSize: 14 }}>
                  {row.uploaded_by}
                </TableCell>

                <TableCell sx={{ fontSize: 14 }}>
                  {row.created_at}
                </TableCell>

                <TableCell sx={{ fontSize: 14 }}>
                  {row.approved_by}
                </TableCell>

                <TableCell
                  sx={{
                    fontSize: 14,
                    maxWidth: 200,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  <Tooltip title={row?.source || ""} arrow>
                    <Typography noWrap>{row?.source}</Typography>
                  </Tooltip>
                </TableCell>

                <TableCell sx={{ textAlign: "center" }}>
                  <IconButton
                    size="small"
                    onClick={(e) => handleClick(e, row)}
                  >
                    <MoreVertIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    {moreOption?.map((option) => (
                      <MenuItem
                        key={option}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOption(rowData);
                        }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Menu>
                </TableCell>
              </TableRow>
            ))}

            {!data?.loader && data?.data?.records?.length === 0 && (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <Typography color="textSecondary">
                    No data found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}